function itemClickEvent() {
  $(".product_box").on("click", " ul.color_list li input", function(){
      $(".product_box").removeClass("active_product");
      $(this).parents(".product_box").addClass("active_product");
      var radioValue = $(".product_box.active_product ul.color_list li input:checked+label").attr("data-value");
      if(radioValue){
         $(".product_box.active_product .product_img img").attr("src", radioValue); 
      }
  });
var max = 3;
$('.product_box ul.color_list').each(function(){
  $(this).find('li').each(function(index){
    if(index >= max) $(this).hide()
  })
})
}
$(document).ready(function() {
    itemClickEvent();
});

  $(".view_details_toggle").click(function(){
    $('html, body').animate({
        scrollTop: $(window).scrollTop() + 500
    }, 500);
    $(".slide_contents").slideToggle();
    $(".overlay_more, .more_btn").hide();
    $(".less_contents").css("height", "auto");
  });

  $(".details_closer").click(function(){
    $(".slide_contents").slideUp();
  });